import { render } from "./TelegramConnect.vue?vue&type=template&id=007a9596"
import script from "./TelegramConnect.vue?vue&type=script&lang=js"
export * from "./TelegramConnect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__